import React, { useState } from 'react';
import moment from 'moment';
import ContactNotes from './ContactNotes';
import { Box, Chip, Button, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

export default function InfoBox(props) {
    const [isContactInfoOpen, setIsContactInfoOpen] = useState(true);
    const [isAbilityHubOpen, setIsAbilityHubOpen] = useState(true);
    const [isNotesOpen, setIsNotesOpen] = useState(true);

    return (
        <>
            {/* Contact Info Section */}
            <div style={{ backgroundColor: 'white', borderRadius: 10, marginTop: 20, marginBottom: 20, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: 5 }}>
                    <h5 style={{ margin: 10 }}>Contact Details:</h5>
                    <i style={{ fontSize: 20, margin: 10 }} onClick={() => setIsContactInfoOpen(!isContactInfoOpen)} className={isContactInfoOpen ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                </div>
                {isContactInfoOpen &&
                    <div style={{ marginTop: -15, paddingBottom: 10 }}>
                        <hr style={{ background: "lightgray" }} />
                        <div style={{ marginLeft: 20, marginRight: 20, marginBottom: 5 }}>
                            {props.data.con_phone?.split(',').slice(1).some(phone => phone.trim()) && (
                                <div style={{ marginBottom: 5 }}>
                                    <h6 style={{ color: 'gray' }}>ADDITIONAL PHONES:</h6>
                                    {props.data.con_phone.split(',').slice(1).filter(phone => phone.trim()).map((phone, index) => (
                                        <div key={index}>{phone.trim()}</div>
                                    ))}
                                </div>
                            )}
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>STATUS:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{props.data.con_status}</h6>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>TYPE:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{props.data.con_contact_type}</h6>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>RELATED CUSTOMER:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{props.data.cus_name ? props.data.cus_name : '-'}</h6>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>PREFERRED COMM. MODE:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{props.data.prefCommMode ? props.data.prefCommMode : '-'}</h6>
                            </div>
                        </div>
                    </div>
                }
            </div>

            {/* AbilityHUB Section */}
            {props.user.subs.find((setting) => setting.feature_id === 22) && (
                <div style={{ backgroundColor: 'white', borderRadius: 10, marginTop: 20, marginBottom: 20, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: 5 }}>
                        <h5 style={{ margin: 10 }}>AbilityHUB:</h5>
                        <i style={{ fontSize: 20, margin: 10 }} onClick={() => setIsAbilityHubOpen(!isAbilityHubOpen)} className={isAbilityHubOpen ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                    </div>
                    {isAbilityHubOpen &&
                        <div style={{ marginTop: -15, paddingBottom: 10 }}>
                            <hr style={{ background: "lightgray" }} />
                            <div style={{ marginLeft: 20, marginRight: 20, marginBottom: 20 }}>
                                <Box sx={{ 
                                    border: '1px solid #e0e0e0', 
                                    borderRadius: '8px',
                                    padding: '16px',
                                    backgroundColor: '#fafafa'
                                }}>
                                    {/* Whether the contact has an AbilityHUB account (looked up by email) */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 1.5 }}>
                                        {!props.data.con_email?.trim() ? (
                                            <>
                                                <Chip size="small" variant="outlined" label="Not on AbilityHUB" />
                                                <Typography variant="caption" sx={{ color: 'gray' }}>No email on file</Typography>
                                            </>
                                        ) : !props.AH_Status ? (
                                            <Typography variant="body2" sx={{ fontSize: '0.875rem', color: 'gray' }}>Checking AbilityHUB…</Typography>
                                        ) : props.AH_Status.onAbilityHub ? (
                                            <>
                                                <Chip size="small" color="success" variant="outlined" icon={<CheckCircleIcon />} label="On AbilityHUB" />
                                                {props.AH_Status.lastLogin && (
                                                    <Typography variant="caption" sx={{ color: 'gray' }}>
                                                        Last signed in {moment.utc(props.AH_Status.lastLogin).local().format('MM/DD/YYYY')}
                                                    </Typography>
                                                )}
                                            </>
                                        ) : props.AH_Status.invited ? (
                                            <>
                                                <Chip size="small" color="warning" variant="outlined" icon={<WarningIcon />} label="Invited, not joined yet" />
                                            </>
                                        ) : (
                                            <Chip size="small" variant="outlined" label="Not on AbilityHUB" />
                                        )}
                                    </Box>

                                    {/* Circle-of-care relationships: role from roleId (1 Contact, 2 Caregiver), status 2 = accepted, 1 = pending */}
                                    {props.AH_Relationships && props.AH_Relationships.length > 0 && (
                                        <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e0e0e0' }}>
                                            <Typography variant="caption" sx={{ color: 'gray', display: 'block', mb: 1 }}>
                                                Circle of Care Relationships:
                                            </Typography>
                                            {props.AH_Relationships.map((rel, index) => {
                                                const accepted = rel.status === 2;
                                                const role = rel.roleId === 1 ? 'Contact' : rel.roleId === 2 ? 'Caregiver' : null;
                                                return (
                                                    <div key={index} className="d-flex align-items-center mb-2">
                                                        <div style={{
                                                            width: 20,
                                                            height: 20,
                                                            borderRadius: '50%',
                                                            backgroundColor: 'gray',
                                                            color: 'white',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
                                                            fontSize: 14,
                                                            marginRight: 10
                                                        }}>
                                                            {index + 1}
                                                        </div>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                                                            <span style={{ fontSize: '0.813rem', fontWeight: 600 }}>{rel.PatientName}</span>
                                                            {role && <span style={{ fontSize: '0.813rem', color: 'gray' }}>{role}</span>}
                                                            <Chip size="small" variant="outlined" color={accepted ? 'success' : 'warning'} label={accepted ? 'Accepted' : 'Pending'} />
                                                            <span style={{ fontSize: '0.75rem', color: 'gray' }}>
                                                                {accepted && rel.confirmedOn
                                                                    ? `Accepted ${moment(rel.confirmedOn).format('MM/DD/YYYY')}`
                                                                    : `Invited ${moment(rel.addedOn).format('MM/DD/YYYY')}`}
                                                            </span>
                                                        </Box>
                                                    </div>
                                                );
                                            })}
                                        </Box>
                                    )}
                                </Box>
                            </div>
                        </div>
                    }
                </div>
            )}

            {/* Notes Section */}
            <div style={{ backgroundColor: 'white', borderRadius: 10, marginTop: 20, marginBottom: 20, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: 5 }}>
                    <h5 style={{ margin: 10 }}>Notes:</h5>
                    <i style={{ fontSize: 20, margin: 10 }} onClick={() => setIsNotesOpen(!isNotesOpen)} className={isNotesOpen ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                </div>
                {isNotesOpen &&
                    <div style={{ marginTop: -15, paddingBottom: 10 }}>
                        <hr style={{ background: "lightgray" }} />
                        <div style={{ marginLeft: 20, marginRight: 20, marginBottom: 20 }}>
                            <div style={{ marginBottom: 20 }}>
                                <ContactNotes contact={props.data} user={props.user} />
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    );
};
